import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllPaymentResponseModel, PaymentModeResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { PaymentModeAdapter } from './dto/payment-mode.adapter';
import { PaymentModeDTO } from './dto/payment-mode.dto';
import { PaymentMode } from './payment-mode.entity';

@Injectable()
export class PaymentModeService {
  
    constructor(
      private logService:LogsService,
        @InjectRepository(PaymentMode)
        private paymentModeRepository: Repository<PaymentMode>,
        private paymentModeAdapter: PaymentModeAdapter,
      ){}
      async getPaymentModeWithoutRelations(paymentMode: string): Promise<PaymentMode>{
        const PaymentModeResponse = await this.paymentModeRepository.findOne({
          where: {paymentMode: Raw(alias => `payment_mode = '${paymentMode}'`)},
        });
        if(PaymentModeResponse){
          return PaymentModeResponse;
        }
        else{
          return null;
        }
      }
  
      async createPaymentMode(paymentModeDTO: PaymentModeDTO, isUpdate: boolean): Promise<PaymentModeResponseModel>{
  
        // const response = new PaymentModeResponseModel();
        try{
          let previousValue
        const paymentModeDtos: PaymentModeDTO[] = [];

          if(!isUpdate){
            const PaymentModeEntity = await this.getPaymentModeWithoutRelations(paymentModeDTO.paymentMode);
            if (PaymentModeEntity){
              throw new PaymentModeResponseModel(false,11104, 'Payment Mode already exists'); 
            }
          }
          else{
            const certificatePrevious = await this.paymentModeRepository.findOne({where:{paymentModeId:paymentModeDTO.paymentModeId}})
            previousValue =(certificatePrevious.paymentMode)
            const PaymentModeEntity = await this.getPaymentModeWithoutRelations(paymentModeDTO.paymentMode);
            if (PaymentModeEntity){
              if(PaymentModeEntity.paymentModeId != paymentModeDTO.paymentModeId ){
                throw new PaymentModeResponseModel(false,11104, 'Payment Mode already exists'); 
              }
            }
          }
          const convertedPaymentModeEntity: PaymentMode = this.paymentModeAdapter.convertDtoToEntity(paymentModeDTO,isUpdate);

          console.log(convertedPaymentModeEntity);
        const savedPaymentModeEntity: PaymentMode = await this.paymentModeRepository.save(convertedPaymentModeEntity);
        const savedPaymentModeDto: PaymentModeDTO = this.paymentModeAdapter.convertEntityToDto(savedPaymentModeEntity);
        paymentModeDtos.push(savedPaymentModeDto)
          console.log(savedPaymentModeDto);
        if (savedPaymentModeDto) {
          const presentValue = paymentModeDTO.paymentMode;
          //generating resposnse
   
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'PaymentMode Updated Successfully': 'PaymentMode Created Successfully'
          const userName = isUpdate? savedPaymentModeDto.updatedUser :savedPaymentModeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'PaymentMode', savedPaymentModeDto.paymentModeId, true, displayValue,userName,previousValue,presentValue)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            const response = new AllPaymentResponseModel(true,1000,isUpdate? 'PaymentMode Updated Successfully': 'PaymentMode Created Successfully');
          return response;
        } else {
          //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
          throw new PaymentModeResponseModel(false,11106,'Payment Mode saved but issue while transforming into DTO');
        }
        // return response;
      } catch (error) {
        // when error occures while saving the data , the execution will come to catch block.
        // tslint:disable-next-line: typedef
        return error;
      }
    }
    async getAllPaymentModes(req:UserRequestDto): Promise<AllPaymentResponseModel> {
      // const page: number = 1;
      // const response = new AllPaymentResponseModel();
      try {
        const paymentModeDTO: PaymentModeDTO[] = [];
        //retrieves all companies
        const PaymentModeEntity: PaymentMode[] = await this.paymentModeRepository.find({ order :{paymentMode:'ASC'}});
        //console.log(statesEntities);
        if (PaymentModeEntity) {
          // converts the data fetched from the database which of type companies array to type StateDto array.
          PaymentModeEntity.forEach(PaymentModeEntity => {
            const convertedPaymentModeDto: PaymentModeDTO = this.paymentModeAdapter.convertEntityToDto(
                PaymentModeEntity
            );
            paymentModeDTO.push(convertedPaymentModeDto);
          });
  
          //generated response

          const response = new AllPaymentResponseModel(true,1,'Payment mode retrieved successfully',paymentModeDTO);
         if(req?.createdUser){
          const newLogDto = new LogsDto(1,'view', 'PaymentMode', 0, true, 'Payment mode retrieved successfully',req.createdUser,'','',)
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
         }
          return response;
        } else {
          throw new PaymentModeResponseModel(false,99998, 'Data not found');
        }
        // return response;
      } catch (err) {
        return err;
      }
    }  

    async getAllActivePaymentModes(): Promise<AllPaymentResponseModel> {
      // const page: number = 1;
      // const response = new AllPaymentResponseModel();
      try {
        const paymentModeDTO: PaymentModeDTO[] = [];
        //retrieves all companies
        const PaymentModeEntity: PaymentMode[] = await this.paymentModeRepository.find({where:{"isActive":true},order :{paymentMode:'ASC'}});
        //console.log(statesEntities);
        
        if (PaymentModeEntity) {
          // converts the data fetched from the database which of type companies array to type StateDto array.
          PaymentModeEntity.forEach(PaymentModeEntity => {
            const convertedPaymentModeDto: PaymentModeDTO = this.paymentModeAdapter.convertEntityToDto(
                PaymentModeEntity
            );
            paymentModeDTO.push(convertedPaymentModeDto);
          });
  
          //generated response

          const response = new AllPaymentResponseModel(true,1,'Payment mode retrieved successfully',paymentModeDTO);
          return response;
        } else {
          throw new PaymentModeResponseModel(false,99998, 'Data not found');
        }
        // return response;
      } catch (err) {
        return err;
      }
    }  
}

